import { useRemindersRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { RemindersSectionContent } from "web_myplann/Reminders/Components/RemindersSectionContent";
import type {
	ReminderEntity,
	RemindersSectionVariant,
} from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
	variant?: RemindersSectionVariant;
};

export const RemindersSection = ({ entity, variant }: Props) => {
	const isEnabled = useRemindersRightOptional();

	if (!isEnabled || !Number.isFinite(entity.id)) {
		return null;
	}

	return <RemindersSectionContent entity={entity} variant={variant} />;
};
